import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { DialogService } from './dialog.service';
import { LoaderService } from './loader.service';

@Injectable({
  providedIn: 'root'
})
export class LoaderInterceptorService implements HttpInterceptor {
  private requests: HttpRequest<any>[] = [];
  private count = 0;
  constructor(
    private loaderService: LoaderService,
    private dialoService: DialogService
  ) { }

  removeRequest(req: HttpRequest<any>) {
    const i = this.requests.indexOf(req);
    if (i >= 0) {
      this.requests.splice(i, 1);
    }
    this.loaderService.isLoading.next(this.requests.length > 0);
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const skip = (req.url.includes('favorites') && req.url.includes('name_like')
    || req.url.includes('cbo') && req.url.includes('profession') || req.url.includes('.svg'))

    if (!skip && this.count === 0) {
      this.loaderService.isLoading.next(true);
    }
    this.count++;
    return next.handle(req).pipe(
      catchError((response: any) => {
        if (response.status === 500) {
          this.dialoService.showDialogError('Estamos com instabilidade no sistema e alguns serviços poderão ser afetados.')
        }
        return throwError(response)
      }),
      finalize(() => {
        this.count--;
        if (this.count === 0) {
          this.loaderService.isLoading.next(false);
        }
      })
    );
  }
}
